import React from "react";




import CountDownOne from "../CountDown/CountDownOne";

const Banner = (props) => {
  return (
    <section className="banner-area banner-bg">
      <div className="banner-shape-wrap">
        
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-content text-center">
             
              <h2 className="title">
              Embrace the Future of Smart Mining with  <span>XMH</span> 
                
              </h2>
            </div>
            
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="banner-countdown-wrap text-center">
             

              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
